export const TABLE_COLUMNS_STORAGE_PREFIX = "table-columns";

export function getTableColumnsStorageKey(tableId, variant) {
  const parts = [TABLE_COLUMNS_STORAGE_PREFIX, tableId, variant].filter(Boolean);

  return parts.join(":");
}

export function normalizeColumnHeaders(headers = []) {
  return headers
    .map((header) => {
      const id = header.id ?? header.value;

      if (id == null || id === "") {
        return null;
      }

      return {
        id,
        title: header.title ?? header.text ?? header.label ?? String(id),
        disabled: Boolean(header.disabled),
      };
    })
    .filter(Boolean);
}

export function getDefaultColumnSettings(headers) {
  const ids = normalizeColumnHeaders(headers).map((header) => header.id);

  return {
    order: [...ids],
    visible: [...ids],
  };
}

export function readColumnSettings(storageKey) {
  if (!storageKey) {
    return null;
  }

  try {
    const stored = window.localStorage.getItem(storageKey);

    if (!stored) {
      return null;
    }

    const parsed = JSON.parse(stored);
    const order = Array.isArray(parsed?.order) ? parsed.order.filter(Boolean) : [];
    const visible = Array.isArray(parsed?.visible) ? parsed.visible.filter(Boolean) : [];

    return { order, visible };
  } catch {
    return null;
  }
}

export function mergeColumnSettings(headers, stored) {
  const defaults = getDefaultColumnSettings(headers);

  if (!stored) {
    return defaults;
  }

  const headerIds = defaults.order;
  const knownIds = new Set(stored.order);
  const nextOrder = [
    ...stored.order.filter((id) => headerIds.includes(id)),
    ...headerIds.filter((id) => !knownIds.has(id)),
  ];
  const nextVisible = [
    ...stored.visible.filter((id) => headerIds.includes(id)),
    ...headerIds.filter((id) => !knownIds.has(id)),
  ];

  return {
    order: nextOrder,
    visible: nextVisible,
  };
}

export function getAppliedColumnIds(headers, storageKey) {
  const settings = mergeColumnSettings(headers, readColumnSettings(storageKey));

  return settings.order.filter((id) => settings.visible.includes(id));
}

export function persistColumnSettings(settings, storageKey) {
  if (!storageKey) {
    return;
  }

  window.localStorage.setItem(storageKey, JSON.stringify(settings));
}

export function applyColumnOrder(headers, appliedIds) {
  return appliedIds
    .map((id) => headers.find((header) => (header.id ?? header.value) === id))
    .filter(Boolean);
}

export function clearAllColumnSettings() {
  const prefix = `${TABLE_COLUMNS_STORAGE_PREFIX}:`;
  const keysToRemove = [];

  for (let i = 0; i < window.localStorage.length; i++) {
    const key = window.localStorage.key(i);

    if (key?.startsWith(prefix)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => window.localStorage.removeItem(key));
}
